import { Component, computed, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StaticTextCPanelComponent } from './customizationPanel';
import { DragDropService } from '../../../services/builder/drag-drop.service';
import { WidgetService } from '../../../services/builder/widget.service';
import { MatButtonModule } from '@angular/material/button';

export interface StaticTextCustomization {
  description: string;
}

@Component({
  selector: 'lib-statictext-edit',
  imports: [MatButtonModule, StaticTextCPanelComponent],
  template: `
    <!-- CONFIGURATION PANEL -->
    @if (widgetService.settingVisibility()) {
      <lib-statictext-custom-panel />
    }

    <!-- OBJECT RAPRESENTATION -->
    @let widget = widgetService.widget();
    @if (widget) {
      <div
        class="relative flex h-full flex-col gap-2 whitespace-normal text-justify"
        [innerHTML]="computedDescription()"
      ></div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class StaticTextComponent {
  protected dragDropService = inject(DragDropService);
  protected widgetService = inject(WidgetService<StaticTextCustomization>);
  private readonly sanitizer = inject(DomSanitizer);

  protected readonly computedDescription = computed(() => {
    const widget = this.widgetService.widget();
    if (!widget) return '';

    const fixed = widget.customization.description.replace(/&nbsp;/g, ' ');
    const safeHtml = this.sanitizer.bypassSecurityTrustHtml(fixed);

    return safeHtml;
  });
}
